import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';

//compont ui:
import DatePicker from '../../components/utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
    FormControl,
    Select,
    InputLabel,
    Paper,
    Button,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';

//actions:
import { navigate, openDialog } from '../../actions';

//helpers:
import { getData, postData } from '../../dataLib';
import * as config from '../../constants/configuration';

const styles = theme => ({
    containerView: {
        width: '83vw',
        height: '83vh',
        marginTop: 135,
    },
    paperCentroDia: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1) / 2,
        paddingLeft: theme.spacing(1) / 2,
        paddingRight: theme.spacing(1) / 2,
        margin: theme.spacing(1),
    },
    form: {
        maxWidth: 595,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 310,
        margin: 0,
        padding: 0,
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '20px !important',
        height: '20px !important',
    },
    textField: {
        width: 145,
        margin: 0,
        padding: 0,
    },
    acceptContainer: {
        width: '19%',
        display: 'flex',
    },
    button: {
        borderRadius: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        color: 'white',
        textTransform: 'capitalize',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class DesbloquearContabilidad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centro: this.props.centroDiaSelected.centro.id
                ? this.props.centroDiaSelected.centro.id
                : 1,
            centroDiaCierre: 1,
            date: null,
            lastExportDate: null,
        };
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        this.getLastExportDate(this.state.centro);
    }

    handleCentroChange = event => {
        const value = parseInt(event.target.value);

        var centroSelected = this.props.centros.find(c => c.id === value);
        if (centroSelected !== undefined) {
            this.getLastExportDate(centroSelected.id);
            this.setState({
                ...this.state,
                centro: centroSelected.id,
                centroDiaCierre: centroSelected.iDiaCierre,
            });
        }
    };

    centroSelectList = () => {
        return this.props.centros
            .filter(c => c.isGroup === false && c.activo === 1)
            .map(centro => {
                return (
                    <option key={centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    handleDateValueChange = event => {
        var dt = new Date(event);
        var lastDate = new Date(this.state.lastExportDate);

        if (dt.getDay() !== this.state.centroDiaCierre || dt > lastDate) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'Selecciona una fecha de cierre semanal anterior a la última fecha de exportación',
                },
                uuidv4(),
                false,
                'sm',
            );

            return;
        }

        this.setState({ ...this.state, date: event });
    };

    getLastExportDate = centro => {
        getData(
            'Contabilidad/UltimaExportacion?centro_id=' + centro,
            response => {
                const dt = new Date(response.data.slice(0, 10));
                const iniDate = new Date(
                    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()),
                );
                this.setState({
                    ...this.state,
                    lastExportDate: iniDate.toISOString().slice(0, 10),
                    date: iniDate.toISOString().slice(0, 10),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching last export date',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    bloquearContabilidad = (centro, date) => {
        postData(
            'contabilidad/bloquearContabilidad?centro_id=' +
            centro +
            '&date=' +
            date,
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Actualizada fecha de última exportación',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
                this.setState({ ...this.state, lastExportDate: date });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR cerrando contabilidad',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            {},
            this.props.user,
        );
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.containerView}>
                <Paper className={classes.paperCentroDia} elevation={0}>
                    <form className={classes.form}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Centro</InputLabel>

                            <Select
                                native
                                value={this.state.centro}
                                onChange={event =>
                                    this.handleCentroChange(event)
                                }
                            >
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>

                        {this.props.isLoading ? (
                            <div className={classes.spinnerContainer}>
                                <CircularProgress
                                    className={classes.spinner}
                                    color="primary"
                                />
                            </div>
                        ) : (
                                ''
                            )}

                        <Tooltip
                            title="Fecha en la que se realizó la última exportación"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 500 }}
                            placement="right"
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <FormControl>
                            <DatePicker
                                label="Última exportación"
                                value={this.state.lastExportDate}
                                className={classes.textField}
                                disabled
                            />
                            </FormControl>
                        </Tooltip>
                    </form>

                    <form className={classes.form}>
                        <Tooltip
                            title="Retroceder bloqueo hasta la fecha ..."
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 500 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <FormControl>
                            <DatePicker
                                label="Retroceder bloqueo"
                                value={this.state.date}
                                className={classes.textField}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleDateValueChange(d.toISOString().slice(0, 10))
                                    }
                                }}
                            />
                            </FormControl>
                        </Tooltip>

                        <div className={classes.acceptContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.props.isLoading ? true : false}
                                className={classes.button}
                                onClick={() => {
                                    const dt = new Date(
                                        this.state.date.slice(0, 10),
                                    );
                                    const newDate = new Date(
                                        Date.UTC(
                                            dt.getFullYear(),
                                            dt.getMonth(),
                                            dt.getDate() + 1,
                                        ),
                                    );
                                    this.bloquearContabilidad(
                                        this.state.centro,
                                        newDate.toISOString().slice(0, 10),
                                    );
                                }}
                            >
                                Retroceder bloqueo
                            </Button>
                        </div>
                    </form>
                </Paper>
                {this.state.pdfLoading ? (
                    <LinearProgress
                        className={classes.linearSpinner}
                        variant="indeterminate"
                    />
                ) : (
                        ''
                    )}
            </div>
        );
    }
}

DesbloquearContabilidad.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        isLoading: state.centros.isLoading,
        centroDiaSelected: state.centroDiaSelected,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            openDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(DesbloquearContabilidad));
